import { render, staticRenderFns } from "./AdditionalZoneEditor.vue?vue&type=template&id=8ad9c736&scoped=true"
import script from "./AdditionalZoneEditor.vue?vue&type=script&lang=ts"
export * from "./AdditionalZoneEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ad9c736",
  null
  
)

export default component.exports